import React from "react";
import { IconContainer, InspectionContainer, InspectionItemText, InspectionItemWrapper } from "./styles";
import ImageContainer from "@components/imageContainer";
import DOMPurify from "isomorphic-dompurify";

const InspectionItems = (props) => {
  console.log('xoxo', props)
  const { options, selfPiOptions, isSelfPi, iconContainerStyles, height=24, width=24, wrapperStyles } = props;

  const RenderInspectionItemForSelfPi = ({selfPiOptions}) => {
    if (!selfPiOptions || !selfPiOptions?.length) return null;

    return selfPiOptions?.map(item => {
      const { imgSrc, text } = item;
      return (
        <InspectionItemWrapper wrapperStyles={wrapperStyles}>
          <IconContainer style= {iconContainerStyles}>
            <ImageContainer imgSrc={imgSrc} height={height} width={width} />
          </IconContainer>
          <InspectionItemText dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}/>
        </InspectionItemWrapper>
      );
    });
  };

  const RenderInspectionItem = ({ options }) => {
    if (!options || !options?.length) return null;

    return options?.map(item => {
      const { imgSrc, text } = item;
      return (
        <InspectionItemWrapper wrapperStyles={wrapperStyles}>
          <IconContainer style= {iconContainerStyles}>
            <ImageContainer imgSrc={imgSrc} height={height} width={width} />
          </IconContainer>
          <InspectionItemText dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}/>
        </InspectionItemWrapper>
      );
    })
  }
  return (
    <InspectionContainer>
      {isSelfPi ? (
        <RenderInspectionItemForSelfPi selfPiOptions={selfPiOptions} />
      ) : (
        <RenderInspectionItem options={options} />
      )}
    </InspectionContainer>
  );
};

export default InspectionItems;
